/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BillingInterval,
    BillingIntervalFromJSON,
    BillingIntervalFromJSONTyped,
    BillingIntervalToJSON,
} from './BillingInterval';
import {
    BillingProductCode,
    BillingProductCodeFromJSON,
    BillingProductCodeFromJSONTyped,
    BillingProductCodeToJSON,
} from './BillingProductCode';
import {
    BillingProductType,
    BillingProductTypeFromJSON,
    BillingProductTypeFromJSONTyped,
    BillingProductTypeToJSON,
} from './BillingProductType';
import {
    BillingTier,
    BillingTierFromJSON,
    BillingTierFromJSONTyped,
    BillingTierToJSON,
} from './BillingTier';
import {
    Currency,
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * 
 * @export
 * @interface BillingProduct
 */
export interface BillingProduct {
    /**
     * 
     * @type {string}
     * @memberof BillingProduct
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingProduct
     */
    active: boolean;
    /**
     * 
     * @type {Currency}
     * @memberof BillingProduct
     */
    amount: Currency;
    /**
     * 
     * @type {number}
     * @memberof BillingProduct
     */
    quantity?: number;
    /**
     * 
     * @type {Date}
     * @memberof BillingProduct
     */
    created: Date;
    /**
     * 
     * @type {BillingInterval}
     * @memberof BillingProduct
     */
    interval: BillingInterval;
    /**
     * 
     * @type {string}
     * @memberof BillingProduct
     */
    name: string;
    /**
     * 
     * @type {BillingProductCode}
     * @memberof BillingProduct
     */
    code: BillingProductCode;
    /**
     * 
     * @type {BillingProductType}
     * @memberof BillingProduct
     */
    type: BillingProductType;
    /**
     * 
     * @type {Array<BillingTier>}
     * @memberof BillingProduct
     */
    tiers?: Array<BillingTier>;
}

export function BillingProductFromJSON(json: any): BillingProduct {
    return BillingProductFromJSONTyped(json, false);
}

export function BillingProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'active': json['active'],
        'amount': CurrencyFromJSON(json['amount']),
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'created': (new Date(json['created'])),
        'interval': BillingIntervalFromJSON(json['interval']),
        'name': json['name'],
        'code': BillingProductCodeFromJSON(json['code']),
        'type': BillingProductTypeFromJSON(json['type']),
        'tiers': !exists(json, 'tiers') ? undefined : ((json['tiers'] as Array<any>).map(BillingTierFromJSON)),
    };
}

export function BillingProductToJSON(value?: BillingProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'active': value.active,
        'amount': CurrencyToJSON(value.amount),
        'quantity': value.quantity,
        'created': (value.created.toISOString()),
        'interval': BillingIntervalToJSON(value.interval),
        'name': value.name,
        'code': BillingProductCodeToJSON(value.code),
        'type': BillingProductTypeToJSON(value.type),
        'tiers': value.tiers === undefined ? undefined : ((value.tiers as Array<any>).map(BillingTierToJSON)),
    };
}

